import { allCards, cardByID, doAction, getCard, getPlayerIndex, logText } from './game.js';
import { orbit, look, closeLook, matches, myAway, cardsInPlay } from './card_actions.js';
import { choose, chooseCards } from './ui.js';
import { res, ui, prefs, state } from './stores.js'
import { get} from 'svelte/store';

export let manualCards = {
    /*'1PIC01/28': { // Picard
        reaction: {
            timing: 'after',
            trigger: (p, owner, c, type, params) => (p == owner && type == 'gain_card' && getCard(params.obj).suits.includes('ally') && p.decks.hand.length > 0),
            action: async (p, owner, c, type, params) => {
                let card = await chooseCards(`Triggering Picard's effect: you may choose a card to discard to gain a [[glory]] and optionally warp the *Enterprise-D*`, p.decks.hand, {optional: true});
                if(card && card != 'cancelled'){
                    await doAction(p, 'discard', {card: card.uniqueID});
                    await doAction(p, 'gain_tokens', {token: 'glory', amount: 1});
                    let uss_e = get(state).cardsByShip['uss_enterprise-d'];
                    await doAction(p, 'warp', {card: uss_e, ship: 'uss_enterprise-d'});
                    //await orbit(p, c, 'uss_enterprise-d', true);
                }else{
                    logText(`Player opted not to use reaction`);
                }
            }
        }
    },
    '1PIC11/26': {
        reaction: {
            timing: 'after',
            trigger: (p, owner, c, type, params) => (p == owner && type == 'gain' && getCard(params.card).suits.includes('ship')),
            action: async (p, owner, c, type, params) => {
                await doAction(p, 'gain_tokens', {token: 'glory', amount: 1})
                // TODO log!
                let play = await choose(`Triggering Geordi LaForge's effect: you gain 1 [[glory]]. Free play the ship?`, ['Yes', 'No']);
                if(play == 'Yes'){
                    await doAction(p, 'freeplay', {card: params.card});
                }
            }
        }
    },
    '1PIC24/26': { // Data
        reaction: {
            timing: 'after',
            trigger: (p, owner, c, type, params) => (p != owner && type == 'gain_tokens' && get(res).trackTypes.includes(params.token) && owner.decks.log.length > 0),
            action: async (p, owner, c, type, params) => {
                let play = await choose(`Triggering Data's effect: junk a card from your Log to gain ${params.amount} [[${params.token}]]?`, ['Yes', 'No']);
                if(play == 'Yes'){
                    let card = await chooseCards(`Choose a card to junk`, owner.decks.log, {optional: true});
                    if(card && card != 'cancelled'){
                        await doAction(p, 'junk', {card: card.uniqueID});
                        await doAction(p, 'gain_tokens', {...params});
                    }
                    
                }
            }
        }
    },
    /*'1PIC26/26': {
        reaction: {
            trigger: (p, owner, c, type, params) => {
                // TODO how do we tell if something is an attack action??
            }
        }
    }*/
}

export function committed(c){
    if(!c.orbiting || c.orbiting.length == 0) return [];
    let set = [];
    for(let s of c.orbiting){
        let card = cardByID(s.card);
        set.push(card);
        if(card.beamed) set.push(...card.beamed);
    }
    return set;
}

function cardsAtMissionOrLocations(p, m){
    let b = Array.from(new Set([...committed(m), ...cardsInPlay(p).filter(c => c.suits.includes('location'))]));
    return b;
}

function cardsAtMissionOrInPlay(p, m){
    let b = Array.from(new Set([...committed(m), ...cardsInPlay(p)]));
    /*for(let c of p.decks.locations){
        b = [...b, ...committed(c)];
    }
    for(let c of get(state).commons.neutral_zone){
        b = [...b, ...b(c).filter(bc => bc.sourcePlayer == getPlayerIndex(p))];
    }*/
    return b;
}

function atLeastHere(p, m, types, num = 1){
    if(!Array.isArray(types)) types = [ types ];
    let count = committed(m).reduce((a,c) => a + matches(c, types, false), 0);
    let wildcardCount = 0;
    if(!types.includes('wildcard')){
        if(types.some(t => t.includes('+'))){
            let doubles = types.filter(t => t.includes('+')).filter(t => committed(m).reduce((a,c) => a + matches(c, t, false),0) == 0);
            if(doubles.length > 0){
                wildcardCount = committed(m).reduce((a,c) => a + matches(c, 'wildcard', false), 0);
                let max = Math.max(...doubles.map(d => d.split('+').length));
                if(wildcardCount < max) return false;
                // TODO need to figure all this out: how to handle wildcards in this very weird situation. Not right yet.
            }

        }else{
            wildcardCount = committed(m).reduce((a,c) => a + matches(c, 'wildcard', false), 0);
        }
    }
    if(num - count <= 0) return true;
    if(num - count - wildcardCount <= 0) return 'wildcard';
    return false;
}

function atLeastHereOrInPlay(p, m, types, num){
    let count = cardsAtMissionOrInPlay(p, m).reduce((a,c) => a + matches(c, types, false), 0);
    
    // Otherwise try filling in via wildcards
    let wildcardCount = 0;
    if(!types.includes('wildcard')) wildcardCount = cardsAtMissionOrInPlay(p, m).reduce((a,c) => a + matches(c, 'wildcard', false), 0);
    //console.log(count, wildcardCount)
    if(num - count <= 0) return true;
    if(num - count - wildcardCount <= 0) return 'wildcard';
    return false;
}

function atLeast(p, places, types, num){
    let count = places.reduce((a,c) => a + matches(c, types, false), 0);
    let wildcardCount = 0;
    if(!types.includes('wildcard')) wildcardCount = places.reduce((a,c) => a + matches(c, 'wildcard', false), 0);
    if(num - count - wildcardCount <= 0) return true;
    return false;
}

function totalShips(p){
    let orbits = [];
    for(let c of allCards()){
        if(c.orbiting) orbits.push(...c.orbiting);
    }
    return orbits.filter(o => o.sourcePlayer == getPlayerIndex(p)).length;
}

function shipsHere(p, c){
    if(!c.orbiting) return 0;
    return c.orbiting.filter(o => o.sourcePlayer == getPlayerIndex(p)).length;
}

export let manualGoals = {
    'receving a distress Call': {
        text: `have 3 [[person]]/[[Ship]] here, with a total of 2+ [[starfleet]]. Have 4 or more [[influence]].`,
        check: (p,m) => {
            return (atLeastHere(p, m, ['person', 'ship'], 3) && atLeastHere(p, m, 'starfleet', 2) && p.influence >= 4);
        }
    },
    'managing a plague outbreak':{
        text: `have at least 3 [[Doctor]]/[[alien]] here or in play.`,
        check: (p, m) => {
            return (atLeastHereOrInPlay(p, m, ['doctor', 'alien'], 3));
        }
    },
    'search for lost transport': {
        text: `have a [[ship]] here and a total of 4+ [[anomaly]]/[[scientist]] here or in play.`,
        check: (p,m) => {
            return (shipsHere(p, m) && atLeastHereOrInPlay(p, m, ['anomaly', 'scientist'], 4))
        }
    },
    'salvage': {
        text: `have at least 3 cards here, each with at least 1 of [[Ferengi]]/[[Pakled]]/[[Shady]].`,
        check: (p,m) => {
            return (committed(m).length >= 3 && committed(m).every(c => matches(c, ['ferengi', 'pakled', 'shady'])));
        }
    },
    'stockpile resources': {
        text: `Have 10+ [[Dilithium]] OR 6+ [[Latinum]].`,
        check: (p,m) => {
            return (p.dilithium >= 10 || p.latinum >= 6)
        }
    },
    'maintain peace': {
        text: `Have 3 controlled [[location]] in play, each with an Away Team.`,
        check: (p,m) => {
            return (p.decks.locations.filter(l => myAway(p, l) >= 1).length >= 3);
        }
    },
    'expanding the empire': {
        text: `Have a total of 6 [[ship]] tokens and/or controlled [[location]] in play, with 1 [[ship]] here.`,
        check: (p,m) => {
            return (p.decks.locations.length + totalShips(p) >= 6 && shipsHere(p, m));
        }
    },
    'romulan weapons trade agreement': {
        text: `have a [[klingon]]+[[ship]] and at least a [[romulan]] here.`,
        check: (p,m) => {
            //console.log(committed(m).map(c => {return {c, m: matches(c, 'klingon+ship')} }))
            let usedWildcard = 0;
            let numWildcards = committed(m).flatMap(c => c.traits).filter(t => t == 'wildcard').length;
            let w1 = atLeastHere(p, m, 'klingon+ship');
            if(!w1) return false;
            if(w1 == 'wildcard') usedWildcard++;
            let w2 = atLeastHere(p, m, 'romulan');
            if(!w2) return false;
            if(w2 == 'wildcard') usedWildcard++;
            if(usedWildcard > numWildcards) return false;
            return true;
        }
    },
    'sabotage': {
        text: `have 2+ [[Weapon]], 1+ [[Scientist]], and 2 [[different-species]] (excluding [[Klingon]]) here.`,
        check: (p,m) => {
            let usedWildcard = 0;
            let numWildcards = committed(m).flatMap(c => c.traits).filter(t => t == 'wildcard').length;
            let w1 = atLeastHere(p, m, 'weapon', 2);
            if(!w1) return false;
            if(w1 == 'wildcard') usedWildcard++;
            let w2 = atLeastHere(p, m, 'scientist');
            if(!w2) return false;
            if(w2 == 'wildcard') usedWildcard++;
            if(usedWildcard > numWildcards) return false;
            let species = Array.from(new Set(committed(m).flatMap(c => c.traits).filter(s => get(res).species.includes(s))));
            let numSpecies = species.filter(s => s != 'klingon').length;
            if(numWildcards > usedWildcard){
                numSpecies += numWildcards - usedWildcard
            }
            if(numSpecies >= 2) return true;
            
            return false;
        }
    },
    'arbiter of succession': {
        text: `have 3 [[klingon]] here.`,
        check: (p,m) => {
            return atLeastHere(p, m, 'klingon', 3);
        }
    },
    'peace negotiations': {
        text: `have 3 [[ally]] here and two of [[military]]/[[influence]]/[[research]] at 4+.`,
        check: (p,m) => {
            return (atLeastHere(p, m, 'ally', 3) && [p.military, p.influence, p.research].filter(t => t >= 4).length >= 2);
        }
    },
    'seek out new life': {
        text: `have 6 [[different-species]] either here or in play. Each [[alien]] counts as a different one. Exclude cards with [[human]]/[[Starfleet]].`,
        check: (p, m) => {
            let eligible = get(res).species.filter(s => s != 'human');
            let species = cardsAtMissionOrInPlay(p,m).filter(c => !c.traits.includes('human') && !c.traits.includes('starfleet')).flatMap(c => c.traits).filter(t => eligible.includes(t));
            let aliens = species.filter(s => s == 'alien');
            let others = Array.from(new Set(species.filter(s => s != 'alien')));
            let wildcards = cardsAtMissionOrInPlay(p,m).flatMap(c => c.traits).filter(t => t == 'wildcard').length;
            //console.log(others, aliens)
            return (aliens.length + others.length + wildcards >= 6);
        }
    },
    'call to arms': {
        text: `Have 7+ [[influence]] OR 7+ [[military]].`,
        check: (p,m) => {
            return (p.influence >= 7 || p.military >= 7);
        }
    },
    'contacting the dominion': {
        text: `have 3 [[dominion]]/[[changeling]] either here or as a [[location]].`,
        check: (p,m) => {
            let cards = cardsAtMissionOrInPlay(p, m).filter(c => matches(c, ['dominion', 'changeling'])); // Wildcards will automatically be included
            let count = 0;
            for(let c of cards){
                count += matches(c, ['dominion', 'changeling'], false); // Exclude wildcards to add later
            }
            count += cards.flatMap(c => c.traits).filter(t => t == 'wildcard').length;
            return count >= 3;
            //return false;//(atLeastHereOrLocations(p, m, ['dominion', 'changeling'], 3));
        }
    },
    'federation membership application': {
        text: `have at least 4 of the same [[any-species]] here or in play. Exclude cards with [[starfleet]].`,
        check: (p,m) => {
            let cards = cardsAtMissionOrInPlay(p, m).filter(c => !c.traits.includes('starfleet'));
            let species = cards.flatMap(c => c.traits).filter(s => get(res).species.includes(s));
            let max = 0;
            let maxSpecies = '';
            for(let s of species){
                let count = species.filter(sp => sp == s).length;
                if(count > max){
                    maxSpecies = s;
                    max = count;
                    //console.log('new max: '+s+' '+count);
                }
            }
            let numWildcards = cards.flatMap(c => c.traits).filter(s => s == 'wildcard').length;
            max += numWildcards;
            m.count = {
                max,
                numWildcards,
                cards,
                species
            }
            if(max >= 4){
                return true;
            }else{
                return false;
            }
        }
    },
    'a call to arms': {
        text: 'Have [[influence]] at 7+ OR [[military]] at 7+.',
        check: (p, m) => {
            return (p.influence >= 7 || p.military >= 7);
        }
    },
    'reunification': {
        text: 'have 4 [[Vulcan]] here or in play.',
        check: (p, m) => {
            return atLeastHereOrInPlay(p, m, 'vulcan', 4)
        }
    },
    'subterfuge': {
        text: 'have 2 different of [[Weapon]]/[[Ambassador]]/[[communication]], and 2 [[different-species]] (excluding cards with [[Romulan]] or [[Reman]]) here.',
        check: (p, m) => {
            let count = 0;
            let wildcardCards = committed(m).flatMap(c => c.traits).filter(t => t == 'wildcard').length;
            let numWildcards = wildcardCards.length;
            let wildcardsUsed = 0;
            for(let t of ['weapon', 'ambassador', 'communication']){
                for(let c of committed(m)){
                    count += matches(c, t, false);
                }
            }
            if(count < 2){
                let diff = 2 - count;
                if(numWildcards > diff){
                    numWildcards -= diff;
                    wildcardsUsed += diff;
                }else{
                    return false;
                }
            }
            if(wildcardsUsed > 0){
                let ineligibleWCs = wildcardCards.filter(c => c.traits.includes('romulan') || c.traits.includes('reman')).length;
                let diff = ineligibleWCs - wildcardsUsed;
                if(diff > 0) numWildcards -= diff; // Any leftover R/R can't be carried into next bit
            }
            let eligible = get(res).species.filter(s => s != 'romulan' && s != 'reman');
            let species = Array.from(new Set(committed(m).filter(c => !c.traits.includes('romulan') && !c.traits.includes('reman')).flatMap(c => c.traits).filter(t => eligible.includes(t))));
            return (species.length + numWildcards >= 2);
        }
    },
    'securing andoria\'s borders': {
        text: 'Have 3 or more controlled locations in play, and 3 [[weapon]] here.',
        check: (p, m) => {
            if(p.decks.locations.length < 3) return false;
            return atLeastHere(p, m, 'weapon', 3);
        }
    },
    'founding the federation': {
        text: 'have 1 [[human]] and 3 different of [[vulcan]]/[[tellarite]]/[[andorian]]/[[alien]]/[[ambassador]]/[[communication]] here.',
        check: (p, m) => {
            if(!atLeastHere(p, m, 'human')) return false;
            let eligible = ['vulcan', 'tellarite', 'andorian', 'alien', 'ambassador', 'communication'];
            let numWildcards = committed(m).flatMap(c => c.traits).filter(t => t == 'wildcard').length;
            let species = Array.from(new Set(committed(m).flatMap(c => c.traits).filter(t => eligible.includes(t))));
            return species.length + numWildcards >= 3
        }
    },
    'andorian mining consortium': {
        text: 'have 3 [[business]] here or in play.',
        check: (p, m) => {
            return atLeastHereOrInPlay(p, m, 'business', 3)
        }
    }

}